import { r as registerInstance, h } from './index-5faac9d7.js';

const preloaderCss = ".pes-preloader{animation:spin 1s linear infinite;background-image:url(\"data:image/svg+xml,%3Csvg width='54' height='54' viewBox='0 0 54 54' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M46 27C46 37.4934 37.4934 46 27 46V54C41.9117 54 54 41.9117 54 27C54 12.0883 41.9117 0 27 0V8C37.4934 8 46 16.5066 46 27Z' fill='%2342B4E6' /%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M27 46C16.5066 46 8 37.4934 8 27C8 16.5066 16.5066 8 27 8V0C12.0883 0 0 12.0883 0 27C0 41.9117 12.0883 54 27 54V46Z' fill='%23E7E6E6' /%3E%3C/svg%3E\");background-position:center;background-repeat:no-repeat;height:100%;margin:0 auto;min-height:60px;width:60px;padding:0}@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}";

const Preloader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return h("div", { class: "pes-preloader" });
  }
};
Preloader.style = preloaderCss;

export { Preloader as pes_preloader };
